import { Modal } from "@breuni-ui/modal";
import { safeDefine } from "@breuni-ui/safe-define";

export class CampModal extends Modal {}

safeDefine("camp-modal", CampModal);
